import { render, staticRenderFns } from "./RecievedSection.vue?vue&type=template&id=7d40002f&scoped=true&"
import script from "./RecievedSection.vue?vue&type=script&lang=js&"
export * from "./RecievedSection.vue?vue&type=script&lang=js&"
import style0 from "./RecievedSection.vue?vue&type=style&index=0&id=7d40002f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d40002f",
  null
  
)

export default component.exports